if (document.querySelector('.teamSwiper')) {
    var swiper = new Swiper('.teamSwiper', {
        speed: 700,
        spaceBetween: 16,
        slidesPerView: 1,
        navigation: {
            nextEl: '.teamSwiper__arrow--right',
            prevEl: '.teamSwiper__arrow--left',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1440: {
                slidesPerView: 5,
            },
        },
    });
}
